import { createPermission } from '@backstage/plugin-permission-common';

const quayViewPermission = createPermission({
  name: "quay.view.read",
  attributes: {
    action: "read"
  }
});
const quayPermissions = [quayViewPermission];

export { quayPermissions, quayViewPermission };
//# sourceMappingURL=permissions.esm.js.map
